import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonButtonRowWidget, UtilityService } from '@eforall/common';
import { CallLink, LinkButtonWidget, EmailLink, AddressLink } from '@eforall/dashboard';
import { Email } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { DomainDataService } from '../../../../../services';
import { PersonDialogDataService } from '../../person-dialog-data.service';


@Component({
	selector: 'person-overview-part',
	standalone: true,
	imports: [
		TabStripModule,
		CommonButtonRowWidget,
		LinkButtonWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-overview.part.html'
})

export class PersonOverviewPart {

	private util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);
	public personDialogDataService = inject(PersonDialogDataService);
	public readonly personDetails = computed(() => {
		const details = this.personDialogDataService.personDetails();
		if (!details) return undefined;

		return {
			...details,
			contactMethodName: details.contactMethodId && this.domainData.data().contactMethodMap[details.contactMethodId]?.name
		};
	});

	public readonly phoneLink = computed(() => {
		const details = this.personDetails();
		if (!details?.phone) return undefined;

		const link: CallLink = {
			linkType: 'call',
			phone: details.phone
		};
		return link;
	});

	public readonly emailLinks = computed(() => {
		const details = this.personDetails();
		if (!details?.emails || details.emails.length === 0) return [];

		return details.emails.map(email => {
			const link: EmailLink = {
				linkType: 'email',
				email: email.email
			};
			return { link, isDefault: email.isDefault };
		});
	});

	public readonly addressLinks = computed(() => {
		const details = this.personDetails();
		if (!details?.placeAddress) return undefined;

		const link: AddressLink = {
			linkType: 'address',
			'street': details.placeAddress,
			'zipId': details.zipId!
		};
		return link;
	});

	sendEmail(emails: Email[]) {
		if (emails.length > 0) {
			const email = emails.find(e => e.isDefault);
			if (email) {
				this.util.send.sendEmail(email.email);
				return;
			}
		}
		console.error('No default email found for sending.');
	}

	sendText(phone: string) {
		this.util.send.sendText(phone);
	}

	openPhone(phone: string) {
		this.util.send.openPhone(phone);
	}

}